"use client";

import { Brand } from "@prisma/client";
import { useEffect, useState } from "react";
import { getBrandLogo } from "./offers/actions";
import { trackEvent } from "./trackEvent";
import ImageWithFallback from "./imageWithFallback";

const Header = ({ brand }: { brand: Brand }) => {
  const [brandLogo, setBrandLogo] = useState<any>(null);

  useEffect(() => {
    (async () => {
      const brandLogo = (await getBrandLogo(brand.id))?.resource;
      setBrandLogo(brandLogo);
    })();
  }, []);

  useEffect(() => {
    // intercept back button
    const onBackButtonEvent = (e: any) => {
      e.preventDefault();
      trackEvent("close-modal", {});
    };

    const handleKeyDown = (e: any) => {
      if (e.key === "Escape") {
        trackEvent("close-modal", {});
      }
    };

    window.addEventListener("popstate", onBackButtonEvent);
    window.addEventListener("keyup", handleKeyDown);

    return () => {
      window.removeEventListener("popstate", onBackButtonEvent);
      window.removeEventListener("keyup", handleKeyDown);
    };
  }, []);

  return (
    <>
      <div className="flex justify-center z-10 top-r">
        <button
          className="absolute top-0 right-4 text-white text-2xl"
          onClick={() => trackEvent("close-modal", {})}
          data-testid="close-checkout"
          aria-label="close checkout modal"
        >
          &times;
        </button>
        <div className="absolute mx-auto bg-white object-contain h-16 p-1">
          <ImageWithFallback
            resource={brandLogo}
            className="object-fit h-full"
          />
        </div>
      </div>
      <div className="bg-primary text-white pt-[70px] pb-0 flex flex-col flex-row justify-between rounded-top">
        <div className="text-[10px] justify-center flex nowrap items-end pb-1 pl-1">
          <img
            className="mb-0.5 mr-1 object-scale-down"
            width={10}
            alt="lock icon"
            src="https://icon-library.com/images/white-lock-icon-png/white-lock-icon-png-16.jpg"
          />
          Secure Payments Powered by
          <img
            className="-m-0.5"
            width={40}
            alt="stripe icon"
            src="https://www.hobbyresources.com/cc/resources/d8ae4b53-ddac-40ec-b010-2e4892237d9d/output/webp/image.webp"
          />
        </div>
      </div>
    </>
  );
};

export default Header;
